import { Link } from "react-router";
import { ShieldAlert } from "lucide-react";
import { useSelector } from "react-redux";
import useRole from "../../hooks/useRole";
import { getOpsHomePath } from "../../utils/opsHome";

export default function UnauthorizedPage() {
  const { roleLabel } = useRole();
  const user = useSelector((state) => state.auth.user);
  const homePath = getOpsHomePath(user);

  return (
    <div className="mx-auto flex max-w-8xl flex-col items-center justify-center px-4 py-24 text-center sm:px-6 lg:px-8">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-red-50 text-red-500">
        <ShieldAlert className="h-8 w-8" />
      </span>
      <h1 className="mt-5 text-xl font-bold text-primary">You don't have access to this page</h1>
      <p className="mt-2 max-w-md text-sm text-primary/50">
        Your role — <span className="font-semibold text-primary/70">{roleLabel}</span> — doesn't include permission
        to view this section. Contact a super admin if you believe this is a mistake.
      </p>
      <Link
        to={homePath}
        className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-bold text-white shadow-md shadow-primary/20 transition-colors hover:bg-primary-light"
      >
        {homePath === "/dashboard" ? "Back to overview" : "Go to home"}
      </Link>
    </div>
  );
}
